// extracted by mini-css-extract-plugin
export default {"root":"Pattern_root__cGft9"};